import { CancelToken } from "axios";
import { axiosInstance } from "./ServiceConstants";

export interface IPoisonQueue {
    queueName: string;
    messageCount: number;
}

class HealthService {
    async getPoisonQueues(cancelToken?: CancelToken): Promise<IPoisonQueue[]> {
        const response = await axiosInstance.get<IPoisonQueue[]>("api/Health/poison-queues", { cancelToken });
        return response.data;
    }

    async reprocessPoisonQueue(queueName: string): Promise<void> {
        await axiosInstance.post(`api/Health/poison-queues/${encodeURIComponent(queueName)}/reprocess`);
    }
}

const HealthServiceInstance = new HealthService();

export default HealthServiceInstance;
